module.exports = __webpack_public_path__ + "static/media/svi-bg1.a2d01260.png";